import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  Label,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

import {
  AvForm,
  AvField,
} from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import showNotification from "../../helpers/show_notification";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { postSubmitForm } from "../../helpers/forms_helper";
import preloader from "../../helpers/preloader";
import { mapUnits } from "../../helpers/units";

const MainStoreItems = (props) => {

  const [selectedRow, setSelectedRow] = useState();

  const { SearchBar } = Search;
  const refForForm = useRef(null);
  useEffect(() => {
    loadAllStores();
  }, []);

  const [allMainStoreeStores, setAllMainStoreStores] = useState([]);
  const [allSubStores, setAllSubStores] = useState([]);
  const [selectedMainStore, setSelectedMainStore] = useState();
  const loadAllStores = async (e, v) => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res1 = response.data.filter((store) => store.type === "Main Store")
      const res2 = response.data.filter((store) => store.type === "Sub Store")
      setAllMainStoreStores(res1);
      res2.forEach((store)=>{
        return (
          store.label=store.name,
          store.value=store._id
          )})
      setAllSubStores(res2);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [main_storeItems, setMainStoreItems] = useState([]);
  const loadMainStoreItems = async (store_id) => {
   try {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "mainstoreitems/main_store_get_mapping";
    let response = await postSubmitForm(url, { store_id: store_id });
    if (response.status === 1) {
      let filtered = response.data?.filter((d)=>d.is_active) || [];
      setMainStoreItems(filtered);
      preloader(false);
    } else {
      showNotification(response.message, "Error");
      preloader(false);
    }
   } catch (error) {
    preloader(false)
    showNotification(error,"error")
   }
  };

  const applyLocalMappingUpdate = (item, type, store) => {
    setMainStoreItems((prev) =>
      prev.map((row) => {
        if (String(row.item_id) !== String(item.item_id)) return row;
        if (type === "add") {
          return { ...row, is_selected: true };
        }
        if (type === "edit") {
          const next = {
            ...row,
            is_selected: true,
            threshold: item.threshold,
            max_order_limit: item.max_order_limit,
          };
          if (store) {
            next.sub_store = store.label || store.name || row.sub_store;
            next.sub_store_id = store.value || store._id || row.sub_store_id;
          }
          return next;
        }
        if (type === "delete") {
          return {
            ...row,
            is_selected: false,
            is_po_allowed: false,
            sub_store: null,
            sub_store_id: null,
          };
        }
        return row;
      })
    );
  };

  const handleItemAction = async (item, type) => {
    const data_to_send = {
      store_id: selectedMainStore.store_id,
      main_store_name: selectedMainStore.main_store_name,
      item_id: item.item_id,
      threshold: item.threshold,
      max_order_limit: item.max_order_limit,
      action: type,
    };

    let url = process.env.REACT_APP_BASEURL + "mainstoreitems/main_store_set_mapping";
    const response = await postSubmitForm(url, data_to_send);
    if (response && response.status === 1) {
      applyLocalMappingUpdate(item, type, selectedStore);
      setEditSubStoreModal(false)
      setSelectedStore()
      setSelectedRow()
      if (type === "add") showToast(props.t(response.message));
      if (type === "edit") showToast(props.t("MainStore item updated."));
      if (type === "delete") showToast(props.t("MainStore item deleted."));
    } else {
      showNotification(response.message, "Error");
    }
  };
  function showPoPermission(cell, row) {
    if (row.is_selected) {
      return (
        <>
          <div className="custom-control custom-switch mb-2" dir="ltr">
            <input
              type="checkbox"
              title="Click to change status."
              className="custom-control-input"
              id={"customSwitch1" + row._id}
              checked={row.is_po_allowed}
            />
            <label
              title="Click to change status."
              className="custom-control-label"
              htmlFor={"customSwitch1" + row._id}
              style={{ "font-weight": "100", cursor: "pointer" }}
              onClick={() => {
                handlePOPermission(row);
              }}
            ></label>
          </div>

          {row.is_po_allowed ? (
            <span class="font-size-12 badge-soft-success badge badge-success badge-pill">
              Yes
            </span>
          ) : (
            <span class="font-size-12 badge-soft-danger badge badge-danger badge-pill">
              No
            </span>
          )}
        </>
      );
    }
    // else {
    //   return (
    //     <span class="font-size-12 badge-soft-danger badge badge-danger badge-pill">
    //       No
    //     </span>
    //   );
    // }
  }

  const [subStoreModal, setSubStoreModal] = useState(false)
  const [editSubStoreModal, setEditSubStoreModal] = useState(false)
  const [selectedStore, setSelectedStore] = useState()

  function selectStoreFormatter(cell, row) {
    if (row.sub_store !=="" && row.sub_store !== undefined && row.sub_store !== null) {
      return (
        <>
        {/* {row.sub_store}&nbsp; &nbsp; */}
          <div className="container d-flex justify-content-between">
          <div>{row.sub_store && row.sub_store}</div>
          <div>
          <span className="text-info">
                <i
                  className="bx bxs-edit font-size-15"
                  title="Click to Edit"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedRow(row);
                    setSelectedStore({label:row.sub_store,value:row.sub_store_id})
                    setEditSubStoreModal(!editSubStoreModal)
                  }}
                ></i>
              </span>
          </div>
          </div>
        </>
      ); 
    }else{
      return (
      <>
      {row.is_selected && (
        <span className="text-info" style={{ fontSize: "25px", color: "blue", fontWeight: "bold" }} >
        <i className="bx bx-plus"
          onClick={() => {
            setSelectedRow(row);
            setSubStoreModal(!subStoreModal)
          }}
        />
        </span>
      )}
      </>
      )
    }
  }

  const handleSelectStore = (data, changedValue) => {
    // select logic 
    if (changedValue.action === "select-option") {
     
      setSelectedStore(data);
    }
    if (changedValue.action === 'remove-value') {
      let UpdatedSelectedItem = selectedStore?.filter(item => item.label !== changedValue.removedValue.label);
      setSelectedStore(UpdatedSelectedItem);
    }

  }


  const columns = [
    {
      dataField: "item_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      csvExport: false,
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Formula"),
      dataField: "unit_levels",
      formatter:(cell,row)=>{
        return mapUnits(row.unit_levels)
      },
      sort: true,
      csvFormatter: (cell, row) => {
        if (row.unit_levels.length > 1) {
          return row.unit_levels.slice(1).map((unit, ind) => {
            const prevUnit = row.unit_levels[ind]?.unit;
            return `1 ${prevUnit} = ${unit.value} ${unit.unit}`;
          }).join('; ');
        } else {
          return row.unit_levels.map(unit => unit.unit).join(', ');
        }
      },
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "is_premium_item",
      text: props.t("Premium Item"),
      sort: true,
      editable:false,
      formatter:(cel,row)=>{
        return row.is_premium_item ? "Yes" :"No"
      },
      csvFormatter: (cell, row) => {
        return row.is_premium_item?"Yes" : "No";
    },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "threshold",
      text: props.t("Threshold"),
      sort: true,
      formatter: (cell, row) => {
        if (row.threshold !== undefined && row.threshold !== null && row.threshold !== "") {
          return row.threshold + " " + row.unit_for_threshold;
        } else {
          return ""; 
        }
      },
      csvFormatter: (cell, row) => {
        return row.threshold+" "+row.unit_for_threshold;
    },
      editable: true,
      type: "number",
      validator: (newValue, row, column) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: 'value should be numeric'
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: 'Value should greater than 0'
          };
        }
        return true;
      },
      attrs: { title: "Click to Edit" },
      style: { cursor: "pointer" },
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    // {
    //   dataField: "sub_store",
    //   text: props.t("Sub Store"),
    //   sort: true,
    //   editable: false,
    //   align: (cell, row, rowIndex, colIndex) => {
    //     return 'center';
    //   },
    //   style: { cursor: "pointer" },
    //   formatter: selectStoreFormatter,
    //   formatExtraData: main_storeItems,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "9%" };
    //   },
    // },
    // {
    //   dataField: "max_order_limit",
    //   text: props.t("Max Order Limit"),
    //   sort: true,
    //   editable: true,
    //   type: "number",
    //   attrs: { title: "Click to Edit" },
    //   style: { cursor: "pointer" },
    //   formatter: (cell, row) => {
    //     if (row.max_order_limit !== undefined && row.max_order_limit !== null && row.max_order_limit !== "") {
    //       return row.max_order_limit + " " + row.unit_for_max_order;
    //     } else {
    //       return ""; 
    //     }
    //   },
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "12%" };
    //   },
    // },
    {
      text: props.t("PO Allowed"),
      formatter: showPoPermission,
      editable: false,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      csvFormatter: (cell, row) => {
        return row.is_po_allowed?"Yes":"No";
      },
      csvExport: true,
    },

    {
      text: props.t("Action"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
      formatter: (cell, row) => {
        if (row.is_selected) {
          return (
            <>
              <button
                class="btn btn-secondary btn-sm btn btn-primary mr-2"
                onClick={() => {
                  handleItemAction(row, "edit");
                }}
              >
                {props.t("Update")}
              </button>
              <button
                class="btn btn-danger btn-sm btn btn-primary"
                onClick={() => {
                  handleItemAction(row, "delete");
                }}
              >
                {props.t("Delete")}
              </button>
            </>
          );
        } else {
          return (
            <button
              class="btn btn-primary btn-sm btn btn-primary"
              onClick={() => {
                handleItemAction(row, "add");
              }}
            >
              {props.t("Add")}
            </button>
          );
        }
      },
      csvExport: false,
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  const MyExportCSV = (props) => {
    const handleClick = () => {
      // passing my custom data
      props.onExport(main_storeItems.filter((r) => r.is_selected));
    };
    return (
      <div>
        <button className="btn btn-success" onClick={handleClick}>
          Export Selected to CSV
        </button>
      </div>
    );
  };

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.is_unsaved) {
      style.backgroundColor = "#ffcc00";
    } else if (row.is_selected) {
      style.backgroundColor = "#c7dced";
    } else {
      style.backgroundColor = "#dadada";
    }

    return style;
  };
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    sizePerPage: 50,
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "Next page",
    prePageTitle: "Previous page",
    firstPageTitle: "First page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
  };
  const handlePOPermission = async (item) => {
    const data_to_send = {
      store_id: selectedMainStore.store_id,
      item_id: item.item_id,
      is_po_allowed: !item.is_po_allowed,
    };
    let url = process.env.REACT_APP_BASEURL + "mainstoreitems/set_po_permission";
    const response = await postSubmitForm(url, data_to_send);
    if (response && response.status === 1) {
      setMainStoreItems((prev) =>
        prev.map((row) =>
          String(row.item_id) === String(item.item_id)
            ? { ...row, is_po_allowed: !item.is_po_allowed }
            : row
        )
      );
      showToast(props.t("PO permission updated."));
    } else {
      showNotification(response.message, "Error");
    }
  };
  const showToast = (message_to_show) => {
    var ele = document.getElementsByName("toastType");
    var position = document.getElementsByName("positions");
    var toastType = "info";
    var title = "";
    var message = message_to_show;

    //Close Button
    var closeButton = true;

    //Progressbar
    var progressBar = true;

    //Duplicates
    var preventDuplicates = false;

    //Newest on Top
    var newestOnTop = true;

    //position class
    var positionClass = "toast-bottom-right";

    //show duration
    var showDuration = 200;

    //Hide duration
    var hideDuration = 1000;

    //timeout
    var timeOut = 2000;

    //extended timeout
    var extendedTimeOut = 1000;

    toastr.options = {
      positionClass: positionClass,
      timeOut: timeOut,
      extendedTimeOut: extendedTimeOut,
      closeButton: closeButton,
      progressBar: progressBar,
      preventDuplicates: preventDuplicates,
      newestOnTop: newestOnTop,
      showDuration: showDuration,
      hideDuration: hideDuration,
    };

    // setTimeout(() => toastr.success(`Settings updated `), 300)
    //Toaster Types
    if (toastType === "info") toastr.info(message, title);
    else if (toastType === "warning") toastr.warning(message, title);
    else if (toastType === "error") toastr.error(message, title);
    else toastr.success(message, title);
  };


  const handleSubmitSelectedStore = async () =>{
    const data_to_send = {
      store_id: selectedMainStore.store_id,
      sub_store_id: selectedStore._id || selectedStore.value,
      main_store_name: selectedMainStore.main_store_name,
      item_id: selectedRow.item_id,
      threshold: selectedRow.threshold,
      max_order_limit: selectedRow.max_order_limit,
      action: "edit",
    };

    let url = process.env.REACT_APP_BASEURL + "main_storeitems/set_mapping";
    const response = await postSubmitForm(url, data_to_send);
    if (response && response.status === 1) {
      applyLocalMappingUpdate(selectedRow, "edit", selectedStore);
      setSubStoreModal(false)
      setSelectedRow()
      setSelectedStore()
      showToast(props.t(response.message));
    } else {
      showNotification(response.message, "Error");
    }
  }
  const handleUpdateSelectedStore = () =>{
    handleItemAction(selectedRow, "edit" )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Store")}
            breadcrumbItem={props.t("Main Store - Items ")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm ref={refForForm}>
                    <CardTitle>{props.t("Main Store - Items ")}</CardTitle>
                    <CardSubtitle className="mb-3">
                      {props.t(
                        "Select a main-store to add/update/delete a item"
                      )}
                    </CardSubtitle>
                    <Row>
                      <Col lg={6}>
                        <AvField
                          name="main_store"
                          // label={props.t("Select Mian Store")}
                          type="select"
                          validate={{ required: { value: true } }}
                          errorMessage={props.t("Main Store cannot be empty")}
                          onChange={(e) => {
                            const selectedIndex =
                              e.target.options.selectedIndex;

                            setSelectedMainStore({
                              store_id: e.target.value,
                              main_store_name:
                                e.target.options[selectedIndex].getAttribute(
                                  "name"
                                ),
                            });
                            loadMainStoreItems(e.target.value);
                          }}
                        >
                          <option value="">
                            {props.t("-- Select Main Store --")}
                          </option>
                          {allMainStoreeStores &&
                            allMainStoreeStores.map((e) => (
                              <option key={e._id} value={e._id} name={e.name}>
                                {e.name}
                              </option>
                            ))}
                        </AvField>
                      </Col>
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Main Store - Items ")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all main store items for selected main store here")}
                  </CardSubtitle>
                  <ToolkitProvider
                    bootstrap4
                    keyField="item_id"
                    data={main_storeItems && main_storeItems}
                    columns={columns}
                    search
                    exportCSV={ {
                      fileName: 'main_store_items.csv',
                    }}
                  >
                    {(propst) => (
                      <div>
                        <Row>
                          <Col lg={4}>
                            <SearchBar
                              {...propst.searchProps}
                              style={{ width: "300px" }}
                            />
                          </Col>
                          <Col lg={4}>&nbsp;</Col>
                          <Col lg={4} className="text-right">
                            <MyExportCSV {...propst.csvProps} />
                          </Col>
                        </Row>
                        <BootstrapTable
                          {...propst.baseProps}
                          pagination={paginationFactory(pagination_options)}
                          noDataIndication={props.t("No data to display.")}
                          striped
                          hover
                          condensed
                          rowStyle={rowStyle}
                          cellEdit={cellEditFactory({
                            mode: "click",
                            blurToSave: true,
                            afterSaveCell: (
                              oldValue,
                              newValue,
                              row,
                              column
                            ) => {
                              if (column.dataField === "is_po_allowed") {
                                if (newValue !== oldValue)
                                  handlePOPermission(row, newValue);
                              }
                            },
                          })}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
         

          {/* Sub Store Modal  */}
          <Modal
            size="md"
            isOpen={subStoreModal}
            toggle={() => setSubStoreModal(!subStoreModal)}
            onClosed={()=>setSelectedStore()}
          >
            <ModalHeader toggle={() => setSubStoreModal(!subStoreModal)}>
              {props.t("Select Sub Store")}
            </ModalHeader>
            <ModalBody>
              <AvForm onValidSubmit={handleSubmitSelectedStore}>
                <Row>

                  <Col lg={12}>
                    <Label>
                      {props.t("Sub Store")}
                    </Label>
                    <Select
                      options={allSubStores}
                      value={selectedStore}
                      onChange={(data, changedValue) => handleSelectStore(data, changedValue)}
                      closeMenuOnSelect={true}
                      classNamePrefix="select"
                      isMulti={false}
                      // className="basic-multi-select"
                    />
                  </Col>

                </Row>
                <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>
                                      </div>
                                    </FormGroup>
                                  </Col>
              </AvForm>
            </ModalBody>
          </Modal>

           {/* Sub Store Edit Modal  */}
           <Modal
            size="md"
            isOpen={editSubStoreModal}
            toggle={() => setEditSubStoreModal(!editSubStoreModal)}
            onClosed={()=>setSelectedStore()}
          >
            <ModalHeader toggle={() => setEditSubStoreModal(!editSubStoreModal)}>
              {props.t("Update Sub Store")}
            </ModalHeader>
            <ModalBody>
              <AvForm onValidSubmit={handleUpdateSelectedStore}>
               {selectedRow&&(
                 <Row>

                 <Col lg={12}>
                   <Label>
                     {props.t("Sub Store")}
                   </Label>
                   <Select
                     options={allSubStores}
                     value={selectedStore && selectedStore}
            onChange={(data, changedValue) => handleSelectStore(data, changedValue)}
                     closeMenuOnSelect={true}
                     classNamePrefix="select"
                     isMulti={false}
                     // className="basic-multi-select"
                   />
                 </Col>

               </Row>
               )}
                <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Update")}
                                        </Button>
                                      </div>
                                    </FormGroup>
                                  </Col>
              </AvForm>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default withRouter(connect(null, {})(withNamespaces()(MainStoreItems)));
